module.exports = __webpack_public_path__ + "media/images/global/icons/planning-6fca816d24f7530472efbd1eacad2d5c.svg";